module.exports = __webpack_public_path__ + "img/bg01.5a0c9e42.png";